import React from "react";
import {
  HeroContainer,
  HeroContent,
  HeroTitle,
} from "./ServiceElements";

const ServiceSection = ({id}) => {

  return (
    <HeroContainer>
      <HeroContent>
        <HeroTitle>Flujo de Servicios</HeroTitle>
      </HeroContent>
    </HeroContainer>
  );
};

export default ServiceSection;
